import React, { forwardRef } from 'react';
import { feedbackModalPropTypes } from './FeedbackModalPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import Checkbox from '@Theme/natucare/components/Checkbox/Checkbox';
import FormLabel from '@Theme/natucare/components/FormLabel/FormLabel';
import Button from '@Theme/natucare/components/Button/Button';
import Textarea from '@Theme/natucare/components/Textarea/Textarea';
import FormControl from '@Theme/natucare/components/FormControl/FormControl';
import FormErrorText from '@Theme/natucare/components/FormErrorText/FormErrorText';
import * as styles from './FeedbackModal.module.scss';
const FeedbackModal = /*#__PURE__*/forwardRef(({
  heading,
  text,
  form,
  error,
  errorMsg,
  onClose,
  onSubmit,
  classname
}, ref) => {
  if (!onClose || !onSubmit) {
    return null;
  }
  const renderTextarea = (placeholder, name, required, index) => /*#__PURE__*/React.createElement(Textarea, {
    placeholder: placeholder,
    name: name,
    error: error,
    required: required,
    key: index
  });
  const renderCheckboxes = items => {
    return items.map(({
      label,
      value,
      name,
      required
    }, index) => /*#__PURE__*/React.createElement(FormLabel, {
      key: index
    }, /*#__PURE__*/React.createElement(Checkbox, {
      value: value,
      name: name,
      error: error,
      required: required || null
    }), label));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname || ''}`
  }, /*#__PURE__*/React.createElement(Icon, {
    onClick: onClose,
    name: "modalClose",
    classname: styles.rootClose,
    size: {
      width: 24,
      height: 24
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootMain
  }, heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), text && /*#__PURE__*/React.createElement("p", {
    className: styles.rootText
  }, text), (form === null || form === void 0 ? void 0 : form.fields) && /*#__PURE__*/React.createElement(FormControl, {
    onSubmit: onSubmit,
    ref: ref
  }, form.fields.map(({
    type,
    items,
    name,
    placeholder,
    required
  }, index) => {
    switch (type) {
      case 'checkbox':
        return renderCheckboxes(items, name, index);
      case 'textarea':
        return renderTextarea(placeholder, name, required, index);
      default:
        return '';
    }
  }), error && /*#__PURE__*/React.createElement(FormErrorText, {
    text: errorMsg
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiaryDark",
    disabled: form.loading,
    type: "submit",
    color: "green",
    classname: styles.rootButton,
    size: "lg",
    icon: form.loading ? 'loading' : null,
    label: !form.loading ? form.submit.label : null
  }))));
});
FeedbackModal.displayName = 'FeedbackModal';
export default FeedbackModal;